import usePageTracking from "../../utils/gtm-page-tracking";
import Buy from "../../components/glucogen/buy";
import { useEffect } from "react";
import TestimonialBanner from "../../components/glucogen/testimonial/banner";
import RealPeople from "../../components/glucogen/testimonial/real-people";
import ProductLabel from "../../components/common/product-label";
import productLabelImg from "../../assets/img/product-gg-label-bottle.png";
import productLabelImgWebp from "../../assets/img/product-gg-label-bottle.webp";
import MoneyBackGuarantee from "../../components/common/money-back-guarantee";
import { ggProductName } from "../../data/product";
import Faq from "../../components/glucogen/faq";
import BuyTitle from "../../components/glucogen/testimonial/buy-title";
import Ingredients from "../../components/common/ingredients";
import { glucoGenIngredients } from "../../data/ingredients";
import CountdownTimer from "../../components/common/countdown";
import TestimonialsTestimonial from "../../components/glucogen/testimonial/testimonial-testimonial";
import TestimonialVideoCarousel from "../../components/glucogen/testimonial/testimonial-video-carousel";
import TopNavBarTestimonial from "../../components/glucogen/testimonial/top-nav-bar";

const TestimonialPage = () => {
    usePageTracking();
    useEffect(() => {
        const script1 = document.createElement('script');
        script1.innerHTML = `
            var mysrc = "https://tracking.buygoods.com/track/?a=11273&firstcookie=0"+"&tracking_redirect=&referrer="+encodeURIComponent(document.referrer)+"&sessid2="+ReadCookie('sessid2')+"&product=glu1,glu3,glu6&vid1=&vid2=&vid3=&caller_url="+encodeURIComponent(window.location.href); if(typeof add_to_cart !== 'undefined') { mysrc = mysrc+'&add_to_cart='+add_to_cart; } var newScript = document.createElement('script'); newScript.type = 'text/javascript'; newScript.defer = true; newScript.src = mysrc; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(newScript, s); function ReadCookie(name){name += '='; var parts = document.cookie.split(/;\s*/);for (var i = 0; i < parts.length; i++) {var part = parts[i]; if (part.indexOf(name) == 0) return part.substring(name.length)} return '';}
        `;
        const script2 = document.createElement('script');
        script2.type = 'text/javascript';
        script2.innerHTML = `
            setTimeout(function () {var i = document.createElement("iframe"),oid = new URLSearchParams(window.location.search);i.async = true;i.style="display:none";i.setAttribute("src", "https://buygoods.com/affiliates/go/conversion/iframe/bg?a=11273&t=d9e2485e36c8c19cbfc7f6acfe589a47&s="+ReadCookie('sessid2'));document.body.appendChild(i);}, 1000);
        `;

        document.head.appendChild(script1);
        document.head.appendChild(script2);

        return () => {
            document.head.removeChild(script1);
            document.head.removeChild(script2);
        };
    }, []);

    return (
        <>
            <TopNavBarTestimonial />
            <TestimonialBanner />
            <RealPeople />
            <TestimonialVideoCarousel
                vidalyticsIds={["uVwZGphU3jwYJiXz", "tbBrwUYLDqIOoMUo", "R0H30ylFRW3n_Txi", "8QQYzNHa88n054Wf"]} 
                mobileVidalyticsIds={["IZv23DsxLHS9TW7m", "y3nWNzmPFu64IbJp", "UhiqSil85qtGEe69", "cGD0iW1QPxQKCfgI"]}                
            />
            <CountdownTimer
                title="Limited Supply.<br />High demand."
                backgroundClass=""
                digitClass="gg-countdown-digit"
            />
            <Buy
                isShown={true}
                showExtraLinks={true}
            />
            <TestimonialsTestimonial />
            <Ingredients
                ingredients={glucoGenIngredients}
                backgroundClass="gg-bg-solid-green"
                title="This original blend of GlucoGen<sup>17</sup> Naturals contains 17 carefully selected ingredients including:"
            />
            <BuyTitle />
            <Buy
                isShown={true}
                showExtraLinks={true}
            />
            <Faq />
            <MoneyBackGuarantee
                backgroundClass="gg-bg-gradient-rb-h"
                productName={ggProductName}
            />
            <ProductLabel
                image={productLabelImg}
                imageWebp={productLabelImgWebp}
                backgroundClass="gg-bg-gradient-v"
            />
        </>
    );
};

export default TestimonialPage;